import utils from '@ehi/global-marketing-interface/lib/utils';

const GMI = utils.getGmiConstants();

export default GMI;
